module.exports = __webpack_public_path__ + "img/appAsset--product-ax.0f5a29f8.svg";